// src/features/auth/Routes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import ForcePasswordChangePage from './pages/ForcePasswordChangePage';
import ForceColorPickerPage from './pages/ForceColorPickerPage';
import ForcePinSetupPage from './pages/ForcePinSetupPage';

export const ProtectedAuthRoutes = () => (
  <>
    {/* Routes only showen when authendicated but no supporting ui (wrapped NullLayout) */}
    <Route path="/force-password" element={<ForcePasswordChangePage />} />
    <Route path="/force-color" element={<ForceColorPickerPage />} />
    <Route path="/force-pin" element={<ForcePinSetupPage />} />
  </>
);